/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_TitleInputs */



/**
* | output |
* | --- |
* | "Project File Loader" |
*
* @param {Load_Project_File_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_title = /** @type {((inputs?: Load_Project_File_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargeur de fichier projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektdatei-Lader")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricatore di file di progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузчик файлов проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargador de archivos de proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目文件加载器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトファイルローダー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट फ़ाइल लोडर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregador de Arquivos de Projeto")
	return /** @type {LocalizedString} */ ("Project File Loader")
});